import { create } from 'zustand';

import {
  AggregationType,
  ChartType,
} from '@/features/charts/components/create-chart-type-selection';
import { getAvailableChartTypes } from '@/features/charts/util/chart-util';
import { KpiType, KpiWithMetrics } from '@/shared/types/api';

interface InsightsHubChartsState {
  timelineChartType: ChartType;
  accumulatedChartType: ChartType;
  timelineChartTypes: ChartType[];
  accumulatedChartTypes: ChartType[];
  setTimelineChartType: (chartType: ChartType) => void;
  setAccumulatedChartType: (chartType: ChartType) => void;
  initializeChartTypes: (kpi: KpiWithMetrics) => void;
}

export const useInsightsHubChartsStore = create<InsightsHubChartsState>(
  (set) => ({
    timelineChartType: ChartType.LINE,
    accumulatedChartType: ChartType.PIE,
    setTimelineChartType: (chartType) => set({ timelineChartType: chartType }),
    setAccumulatedChartType: (chartType) =>
      set({ accumulatedChartType: chartType }),
    initializeChartTypes: (kpi: KpiWithMetrics) => {
      const timelineChartTypes = getAvailableChartTypes({
        aggregationType: AggregationType.TIMELINE,
        kpiType: kpi.type as KpiType,
        maxValue: kpi.max_value ? kpi.max_value : undefined,
      });
      const timelineType = timelineChartTypes[0] || ChartType.LINE; // Use first available or fallback to LINE

      var accumulatedChartTypes = getAvailableChartTypes({
        aggregationType: AggregationType.ACCUMULATED,
        kpiType: kpi.type as KpiType,
        maxValue: kpi.max_value ? kpi.max_value : undefined,
      });

      const accumulatedType = accumulatedChartTypes[0] || ChartType.PIE;

      set({
        timelineChartType: timelineType,
        accumulatedChartType: accumulatedType,
        timelineChartTypes: timelineChartTypes,
        accumulatedChartTypes: accumulatedChartTypes,
      });
    },
    timelineChartTypes: [],
    accumulatedChartTypes: [],
  }),
);
